const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Assignments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Assignments', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/assignments/:subresource/:remindid', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    search: {params: {subresource: 'search'}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    overviewStats: {params: {subresource: 'overview-stats'}, method: 'GET', isArray: false},
    manualComplete: {params: {remindid: 'manual-complete'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    distribute: {params: {subresource: 'distribute'}, method: 'POST', isArray: false},
    completeContent: {params: {subresource: 'complete-item'}, method: 'POST', isArray: false},
    // create: {params: {subresource: ''}, method: 'POST', isArray: false},
    queryCreate: {params: {subresource: 'query'}, method: 'POST', isArray: false},
    remind: {params: {subresource: 'reminder'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);